/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Sector object
 */
export interface Sector { 
    /**
     * GEWE customer \'Branche\'; internal SAP ID of sector
     */
    sectorId?: string;
    /**
     * text value of sector
     */
    text?: string;
}

